import { apiRequest } from "./apiClient";

export function listUsers({ page = 0, size = 20, query, role, active } = {}) {
  const safePage = Math.max(0, Number(page) || 0);
  const safeSize = Math.min(100, Math.max(1, Number(size) || 20));
  const filters = new URLSearchParams();
  if (query) filters.set("query", query);
  if (role) filters.set("role", role);
  if (active !== undefined && active !== "") filters.set("active", active);
  return apiRequest(`/api/users?page=${safePage}&size=${safeSize}${filters.toString() ? `&${filters}` : ""}`);
}

export function createUser(values) {
  return apiRequest("/api/users", { method: "POST", body: JSON.stringify(values) });
}

export function updateUser(id, values) {
  return apiRequest(`/api/users/${id}`, { method: "PUT", body: JSON.stringify(values) });
}

export function getUserPermissions(id) {
  return apiRequest(`/api/users/${id}/permissions`);
}

export function updateUserPermissions(id, permissions) {
  return apiRequest(`/api/users/${id}/permissions`, {
    method: "PUT",
    body: JSON.stringify({ permissions }),
  });
}

export function resetUserPassword(id, values) {
  return apiRequest(`/api/users/${id}/reset-password`, {
    method: "PUT",
    body: JSON.stringify(values),
  });
}
